export function PostTypeData() {
    return {
        name: "post_type",
        label: "Post Type",
        primitiveType: "string",
    };
}

export default PostTypeData;
